export default function getHostname(url) {
  const { hostname } = new URL(url);
  return hostname;
}
